import { render, staticRenderFns } from "./street.vue?vue&type=template&id=0530a122&scoped=true"
import script from "./street.vue?vue&type=script&lang=js"
export * from "./street.vue?vue&type=script&lang=js"
import style0 from "./street.vue?vue&type=style&index=0&id=0530a122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530a122",
  null
  
)

export default component.exports